import axios from 'axios';

import RequestHeadersBase from '~/common/constants/RequestHeadersBase';
import RequestHeadersPlatform from '~/common/constants/RequestHeadersPlatform';
import { handleRefreshInterceptor } from '~/services/interceptors/handle-refresh.interceptor';
import { setAuthTokenInterceptor } from '~/services/interceptors/set-auth-token.interceptor';
import {
  GeoComplyReasonCode,
  GeoComplyTokenType,
  Method,
  setLocationInterceptor,
} from '~/services/interceptors/set-location.interceptor';

export const contestsServiceInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_SPLASH}contests-service/api`,
  headers: {
    ...RequestHeadersBase,
  },
});

setAuthTokenInterceptor(contestsServiceInstance);
handleRefreshInterceptor(contestsServiceInstance);
setLocationInterceptor(contestsServiceInstance, [
  [
    Method.POST,
    '/v2/entries',
    { reasonCode: GeoComplyReasonCode.PURCHASE_WAGER, tokenType: GeoComplyTokenType.VALID },
  ],
  [
    Method.POST,
    '/buybacks',
    { reasonCode: GeoComplyReasonCode.PURCHASE_WAGER, tokenType: GeoComplyTokenType.VALID },
  ],
]);

export const contestsServiceV2Instance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_SPLASH}contests-service-v2/api`,
  headers: {
    ...RequestHeadersBase,
  },
});

setAuthTokenInterceptor(contestsServiceV2Instance);
handleRefreshInterceptor(contestsServiceV2Instance);

export const contestImageUploadService = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_SPLASH}contests-service/api/assets`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
    ...RequestHeadersPlatform,
  },
});

setAuthTokenInterceptor(contestImageUploadService);
handleRefreshInterceptor(contestImageUploadService);
